import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './styles/globals.scss';
import App from './app/app';
import { ThemeProvider } from './styles/ThemeProvider';
import { AuthProvider } from './context/AuthContext';
import { ReadingPreferencesProvider } from './context/ReadingPreferencesContext';
import { LocaleProvider } from './context/LocaleContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Create a wrapper component to handle theme
function Root() {
  return (
    <React.StrictMode>
      <ThemeProvider>
        <LocaleProvider>
          <ReadingPreferencesProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ReadingPreferencesProvider>
        </LocaleProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
